var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58579 4.58579C4.40007 4.7715 4.25275 4.99198 4.15224 5.23463C4.05173 5.47728 4 5.73736 4 6C4 6.26264 4.05173 6.52272 4.15224 6.76537C4.25275 7.00802 4.40007 7.2285 4.58579 7.41421",
    stroke: "var(--color, #BDBFBF)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41421 4.58579C7.59993 4.7715 7.74725 4.99198 7.84776 5.23463C7.94827 5.47728 8 5.73736 8 6C8 6.26264 7.94827 6.52272 7.84776 6.76537C7.74725 7.00802 7.59993 7.2285 7.41421 7.41421",
    stroke: "var(--color, #BDBFBF)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6C2 7.06087 2.42143 8.07828 3.17157 8.82843",
    stroke: "var(--color, #BDBFBF)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82843 3.17157C9.57857 3.92172 10 4.93913 10 6C10 7.06087 9.57857 8.07828 8.82843 8.82843",
    stroke: "var(--color, #BDBFBF)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L10 10",
    stroke: "#F52E2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.e18648e58b2c752e1d3ca23611bb459d.svg";
export { ForwardRef as ReactComponent };